module.exports = __webpack_public_path__ + "img/supbg3.8520618c.jpg";